import { Control } from "../../UI.BaseControls/Control";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { IBaseAction } from "../Actions/IAction";
import { IDropDownMenuItem } from "./DropDownInterfaces";
import { DropDownMenu } from "./DropDownMenu";

export class SeparatorMenuItem extends Control implements IDropDownMenuItem {
    protected _textElement: HTMLElement;
    protected _isRendered: boolean = false;

    public icon: string;
    public priority: number = 15;
    public action: IBaseAction;
    public parent: DropDownMenu;
    public isOpened: boolean;

    protected override _constructor(): void {
        super._constructor();

        this.priority = 15;
        this._createElement();
    }

    protected _createElement(): void {
        this.classList.add("Separator");
        const el = document.createElement("div");
        const el2 = document.createElement("div");

        el.classList.add("Icon");
        el2.classList.add("Line");

        this.appendChild(el);
        this.appendChild(el2);
    }
}

registerCustomElement("tsc-SeparatorMenuItem", SeparatorMenuItem);
